<template>
<div class="a-vg-header--main-slider">
  <div class="slides-container">
    <transition name="slide">
      <div class='slide'>
        <div class="a-vg-header--video-results">
          <div class="label-wrap">
            <h3 class="label">
              {{this.$t('vdog_round_no')}} {{roundNo % 1000}} {{this.$t('vdog_result')}}
            </h3>
          </div>
          <div class="results-table">
            <div class="row">
              <!-- Single score -->
              <vdog-winner-placement-single-row
                v-if="firstPosition > 0"
                class="single-score winner"
                :match="match"
                :awardPlace="1"
                :place="firstPosition" />
              <!-- Single score -->
              <vdog-winner-placement-single-row
                  v-if="secondPosition > 0"
                  class="single-score"
                  :match="match"
                  :awardPlace="2"
                  :place="secondPosition" />
              <!-- Single score -->
              <vdog-winner-placement-single-row
                  v-if="thirdPosition > 0"
                  class="single-score"
                  :match="match"
                  :awardPlace="3"
                  :place="thirdPosition" />
              </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</div>
</template>

<script>
import VDogWinnerAndPlacementBettingSingleRow from '@/components/grayhound/results/VDogWinnerAndPlacementBettingSingleRow.vue'

import vuexStore from '../../../store/vuexStore'

import results from '../../../assets/audio/results.mp3'

export default {
  components: {
    'vdog-winner-placement-single-row': VDogWinnerAndPlacementBettingSingleRow
  },
  props: {
    roundNo: Number,
    match: {
      type: Object,
      required: true
    },
    roundResult: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  mounted () {
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
    if (this.hasAudioEnabled) {
      var audio = new Audio(results)
      audio.play()
    }
  },
  computed: {
    firstPosition: function () {
      return this.roundResult ? this.roundResult.FirstPlace || -1 : -1
    },
    secondPosition: function () {
      return this.roundResult ? this.roundResult.SecondPlace || -1 : -1
    },
    thirdPosition: function () {
      return this.roundResult ? this.roundResult.ThirdPlace || -1 : -1
    }
  }
}
</script>
